import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=455f8a2f&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=455f8a2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f8a2f",
  null
  
)

export default component.exports